import { AnyAction } from "redux";

import { takeLatest, call, put, takeEvery, select, delay } from "redux-saga/effects";
import { AAD_LOGIN_SUCCESS } from "./actions";
import cfg from "../config";
import { authProvider } from "../authProvider";
import {
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGIN_COMPLETE,
  UPDATE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION_SUCCESS,
  ACCEPT_TERMS,
} from "../../common/redux/actions";
import { userSelector } from "../../common/redux/selectors";

const fetchUser = async (url: string, opts: { [key: string]: any }) => {
  const response = await fetch(url, opts);
  return await response.json();
};

function* userSaga({ payload }: AnyAction): any {
  const token = payload.jwtIdToken;
  const user = payload.account.userName;
  const usersUrl = `${cfg.usersUrl}/users/${user}`;

  const opts = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const userResponse = yield call(fetchUser, usersUrl, opts);

  yield put({
    type: LOGIN_COMPLETE,
    payload: {
      aadResponse: payload,
      userResponse,
    },
  });
}

function* userSubscriptionSaga({ payload }: AnyAction): any {
  const subscription = payload.subscribeToEmails;
  const upn = payload.upn;
  const token = payload.token;
  const usersUrl = `${cfg.usersUrl}/users/${upn}/${subscription ? "unsubscribe" : "subscribe"}`;

  const postOpts = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
  const userResponse: { subscribeToEmails: boolean } = yield call(fetchUser, usersUrl, postOpts);

  yield put({
    type: UPDATE_SUBSCRIPTION_SUCCESS,
    payload: {
      subscribeToEmails: userResponse.subscribeToEmails,
    },
  });
}

function* pollRefresh() {
  while (true) {
    // refresh the token every 30 mins to avoid users experiencing token expiry
    yield delay(30 * 60 * 1000);
    const opts = authProvider.getAuthenticationParameters();
    yield call([authProvider, authProvider.getIdToken], {
      ...opts,
      forceRefresh: true,
    });
    // the reducer will pick up an action initiated by the msal library to stash the new token
  }
}

export function* logout() {
  yield call(authProvider.logout);
  yield put({
    type: LOGOUT_SUCCESS,
  });
}

export function* acceptTerms() {
  const user: ReturnType<typeof userSelector> = yield select(userSelector);
  const upn = user?.upn;
  const token = user?.token;
  const usersUrl = `${cfg.usersUrl}/users/${upn}/termsandconditions?accepted=true`;

  const postOpts = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
  const userResponse: { acceptedTerms: boolean } = yield call(fetchUser, usersUrl, postOpts);

  yield put({
    type: UPDATE_SUBSCRIPTION_SUCCESS,
    payload: {
      acceptedTerms: userResponse.acceptedTerms,
    },
  });
}

export function* rootSaga() {
  yield takeLatest(AAD_LOGIN_SUCCESS, userSaga);
  yield takeLatest(LOGOUT, logout);
  yield takeLatest(ACCEPT_TERMS, acceptTerms);
  yield takeEvery(UPDATE_SUBSCRIPTION, userSubscriptionSaga);
  yield pollRefresh();
}
